import React from 'react';
import '../styles/Contatti.css';
import discordLogo from '../assets/discord-round-color-icon.png';
import telegramLogo from '../assets/Telegram_2019_Logo.svg.webp';
import youtubeLogo from '../assets/youtube-logo.png';
import twitchLogo from '../assets/twitch-logo.png';

// Componente SVG per l'avatar di default
const DefaultAvatar = () => (
  <svg 
    className="default-avatar-svg"
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6ZM12 20C9.97 20 8.16 19.16 6.85 17.79C7.81 16.51 10.19 15.5 12 15.5C13.81 15.5 16.19 16.51 17.15 17.79C15.84 19.16 14.03 20 12 20Z" fill="#cccccc"/>
  </svg>
);

const communityFounders = [
{
    name: 'Simorz',
    avatar: null, 
    youtube: 'https://www.youtube.com/@simorz',
    twitch: null,
    discord: 'simorz' // Nome utente discord
  },
  // {
  //   name: 'Devix',
  //   // Avatar nullo o placeholder -> mostrerà l'icona di default
  //   avatar: null, 
  //   youtube: null,
  //   twitch: null,
  // },
];

const communityStaff = [
  // { 
  //   name: 'Davide03gm', 
  //   discord: 'davide03gm', 
  //   avatar: null,
  //   youtube: 'https://youtube.com/...', // Esempio opzionale
  //   twitch: null 
  // },
  { name: 'Davide', discord: 'davide03gm', avatar: null },
  { name: 'Ludovix', discord: 'ludovix2812', avatar: null },
  { name: 'Zocch', discord: 'z0cch', avatar: null },
  { name: 'Ariel', discord: 'ariel.ita', avatar: null },
  { name: 'Edo', discord: 'callmedo_', avatar: null },
  { name: 'Bluestone', discord: 'bluestone17', avatar: null },
];

const socialLinks = [
  { img: discordLogo, url: 'https://discord.gg/A5yyPaw', alt: 'Discord' },
  { img: telegramLogo, url: 'https://t.me/Just4FunOGGICIALGROUP', alt: 'Telegram' },
  { img: youtubeLogo, url: '#', alt: 'YouTube' },
  { img: twitchLogo, url: '#', alt: 'Twitch' },
];

const Contatti = () => {
  const getDiscordLink = (username) => `https://discord.com/users/${username}`;

  // Funzione che crea la card: la usiamo sia per Founder che per Staff
  const renderMemberCard = (member, isStaff = false) => (
    <div className={`member-card ${isStaff ? 'staff-clickable' : ''}`} key={member.name}>
      <div className="avatar-wrapper">
        {member.avatar ? (
          <img src={member.avatar} alt={member.name} className="member-avatar" />
        ) : (
          <DefaultAvatar />
        )}
      </div>
      
      <h3>{member.name}</h3>
      
      <a href={getDiscordLink(member.discord)} target="_blank" rel="noreferrer" className="discord-tag">
        @ {member.discord}
      </a>

      <div className="member-socials">
        {member.youtube && (
          <a href={member.youtube} target="_blank" rel="noreferrer" className="btn-social yt">YouTube</a>
        )}
        {member.twitch && (
          <a href={member.twitch} target="_blank" rel="noreferrer" className="btn-social tw">Twitch</a>
        )}
      </div>
    </div>
  );

return (
    <div className="home-page">
      <div className="home-container">
        <h1 className='titolo-principale'>Contattaci</h1>
        <p className="email-info">
          Per maggiori informazioni, scrivici a <a href="mailto:info@just4fun.it">info@just4fun.it</a>
        </p>
        
        <h2 className='sottotitolo-sezione'>I nostri Social</h2>
        <div className="social-grid-mini">
          {socialLinks.map((social, index) => (
            <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" className="social-mini-card">
              <img src={social.img} alt={social.alt} />
            </a>
          ))}
        </div>

        <div className="community-section">
          <h2 className='titolo-sezione'>Founders</h2>
          <div className="members-grid">
            {communityFounders.map(member => renderMemberCard(member))}
          </div>
        </div>

        <div className="community-section">
          <h2 className='titolo-sezione'>Staff</h2>
          <div className="members-grid-staff">
            {communityStaff.map(member => renderMemberCard(member, true))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contatti;